module.exports = __webpack_public_path__ + "slide5-release-ie11.abd2f814f9741d7a70847a92ac099143.hashedasset.svg";